import React, {useCallback, useEffect, useRef, useState} from 'react';
import {NavigationProps} from "../constants/Props";
import Title from "../components/Title";
import PhoneNumberInput from "../components/PhoneNumberInput";
import Screen from "../components/Screen";
import Box from "../components/Box";
import {IAuthStore} from "../stores/AuthStore";
import {observer} from "mobx-react";
import {toI18N} from "../utils/I18n";
import Alert, {AlertRefProps} from "../components/Alert";
import classNames from "classnames";
import styles from "../css/Text.module.css";
import {usePrevious} from "../utils/HooksHelper";
import * as Analytics from "../utils/Analytics";

interface Props extends NavigationProps {
    store: IAuthStore,
}

function PhoneNumberScreen(props: Props) {
    const {
        onNext, store: {
            requestPhoneNumberVerificationCode, setPhoneNumber, defaultCountryCode, setCountryCode, isUnknownPhoneNumber,
        }, onBack,
        isActive,
    } = props;

    const prevIsActive = usePrevious(isActive);
    useEffect(() => {
        if (!prevIsActive && isActive) {
            Analytics.logEvent(Analytics.events.land_on_login_page);
        }
    });

    const [isLoading, setIsLoading] = useState(false);

    const alertRef = useRef<AlertRefProps>(null);
    const error = useCallback(
        (text) => {
            alertRef && alertRef.current && alertRef.current.error(text);
        },
        [alertRef],
    );

    const handleOnNext = useCallback(
        async (e) => {
            try {
                setIsLoading(true);
                const isValid = await requestPhoneNumberVerificationCode();
                setIsLoading(false);
                if (!isValid) return;
                // TODO: Don't navigate on the backoffTime > 0
                onNext && onNext(e);
            } catch (e) {
                setIsLoading(false);
                if (e.timeout) {
                    error(toI18N("general_timeout_error"));
                    return
                }
                console.error(e)
            }
        },
        [error, requestPhoneNumberVerificationCode, onNext],
    );

    return (
        <Screen
            isLoading={isLoading}
            title={"phone_number_screen_header_title"}
            subtitle={"phone_number_screen_header_subtitle"}
            disabledNext={!props.store.phoneNumberCanProceed}
            onBack={onBack}
            onNext={handleOnNext}>

            <Alert ref={alertRef}/>

            <Box center topMargin={116}>
                <Title shrink title={toI18N("phone_number_title")}
                       subtitle={toI18N("phone_number_subtitle")}/>
            </Box>

            <Box grow top sideMargin topMargin={54}>
                <PhoneNumberInput
                    id={'phone-number-input-phone-number-screen'}
                    defaultCountryCode={defaultCountryCode}
                    onSetCountryCode={setCountryCode}
                    onSetPhoneNumber={setPhoneNumber}
                />
                {isUnknownPhoneNumber ? <h3 style={{color: "red"}}
                        className={classNames({[styles.h3Xs]: true,})}>{toI18N("phone_number_is_invalid_1")}<a
                        href="https://home.the.select/">{toI18N("phone_number_is_invalid_click_here")}</a> {toI18N("phone_number_is_invalid_2")}
                    </h3>
                    : null}
            </Box>

        </Screen>
    );
}

export default observer(PhoneNumberScreen);
